@if (tables$ !== undefined) {
  <form [formGroup]="linkForm" (ngSubmit)="onSubmit()">
    <fieldset formGroupName="tables">
      <legend>Tables liées</legend>
      <label for="table1">Table 1</label>
      <select name="table1" formControlName="table1" id="table1" (change)="watchChangeInForm()">
        <option value="">--Choisissez une table--</option>
        @for (table of tables$ | async; track $index) {
          <option [value]="table">{{ table }}</option>
        }
      </select>
      <label for="table2">Table 2</label>
      <select name="table2" formControlName="table2" id="table2" (change)="watchChangeInForm()">
        <option value="">--Choisissez une table--</option>
        @for (table of tables$ | async; track $index) {
          <option [value]="table">
            <span>{{ table }}</span>
          </option>
        }
      </select>

      @if (linkForm.get('tables')?.invalid && linkForm.touched) {
        <ul class="error">
          @if (linkForm.get('tables')?.errors) {
            <li>{{ linkForm.get('tables')?.errors?.['namesMatch'] }}</li>
            <li>{{ linkForm.get('tables')?.errors?.['linkExists'] }}</li>
          }
        </ul>
      }
    </fieldset>
    @if (linkForm.get('tables')?.valid) {
      <fieldset>
        <legend>Verbe de lien</legend>
        <label for="action">Action</label>
        <input type="text" name="action" id="action" formControlName="action" (change)="watchChangeInForm()" />
        @if (linkForm.get('action')?.invalid && linkForm.touched) {
          <ul class="error">
            @if (linkForm.get('action')?.errors?.['required']) {
              <li>L'action est requise.</li>
            }
          </ul>
        }
      </fieldset>
    }

    @if (linkForm.get('tables')?.valid && linkForm.get('action')?.valid) {
      <fieldset>
        <legend>Type de relation</legend>
        <ul>
          @for (relation of relationTypeList; track $index) {
            <li>
              <input [id]="relation" type="radio" [value]="relation" formControlName="relationType" (change)="watchChangeInForm()" />
              <label [for]="relation">{{ relation }}</label>
            </li>
          }
        </ul>
        <div>
          <label for="lang">Show sentence in English</label>
          <input type="checkbox" id="lang" (change)="toggleLang()" [checked]="isEnglish" />
        </div>
        @if (linkForm.get('relationType')?.invalid && linkForm.touched) {
          <ul class="error">
            @if (linkForm.get('relationType')?.errors?.['required']) {
              <li>Un type de relation est requis.</li>
            }
          </ul>
        }
        @if (linkForm.get('relationType')?.valid) {
          <div id="relationTypeResult">
            <strong>
              {{ sentence }}
            </strong>
          </div>
        }
      </fieldset>
    }
    <button type="submit" [disabled]="linkForm.invalid" class="button-component">Submit</button>
  </form>
}
